<template>
  <aside
    :class="[
      'dir-sidebar',
      'd-none',
      'd-lg-block',
      { 'is-collapsed': collapsed }
    ]"
  >
    <div class="dir-sidebar-header">
      <template v-if="!collapsed">
        <i class="el-icon-goods dir-sidebar-icon"></i>
        <span class="dir-sidebar-title">Catálogo</span>
      </template>
      <button
        class="dir-sidebar-toggle"
        @click="toggleCollapse"
        :title="collapsed ? 'Expandir' : 'Colapsar'"
      >
        <i
          :class="collapsed ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"
        ></i>
      </button>
    </div>

    <nav class="dir-sidebar-nav">
      <el-tooltip
        v-for="item in navItems"
        :key="item.key"
        :content="item.label"
        placement="right"
        :disabled="!collapsed"
      >
        <a
          class="dir-sidebar-item"
          :class="{
            active: activeTab === item.key,
            'dir-sidebar-item--locked': item.locked
          }"
          @click="$emit('change-tab', item.key)"
        >
          <i :class="item.icon" class="dir-sidebar-item-icon"></i>
          <span v-if="!collapsed" class="dir-sidebar-item-label">{{
            item.label
          }}</span>
          <span
            v-if="!collapsed && item.count !== null && !item.locked"
            class="dir-sidebar-item-count"
            >{{ item.count }}</span
          >
          <svg
            v-if="!collapsed && item.locked"
            class="dir-sidebar-lock"
            width="11"
            height="11"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </a>
      </el-tooltip>
    </nav>
  </aside>
</template>

<script>
const STORAGE_KEY = "mydessk_sidebar_collapsed";

export default {
  name: "CatalogueSidebar",
  props: {
    activeTab: { type: String, default: "products" },
    productCount: { type: Number, default: 0 },
    categoryCount: { type: Number, default: 0 },
    inventoryLocked: { type: Boolean, default: false }
  },
  data() {
    return {
      collapsed: localStorage.getItem(STORAGE_KEY) === "true"
    };
  },
  computed: {
    navItems() {
      return [
        {
          key: "products",
          label: "Productos",
          icon: "el-icon-goods",
          count: this.productCount
        },
        {
          key: "categories",
          label: "Categorías",
          icon: "el-icon-collection-tag",
          count: this.categoryCount
        },
        {
          key: "movements",
          label: "Inventario",
          icon: "el-icon-box",
          count: null,
          locked: this.inventoryLocked
        }
      ];
    }
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed;
      localStorage.setItem(STORAGE_KEY, this.collapsed);
    }
  }
};
</script>

<style scoped>
.dir-sidebar-item--locked {
  opacity: 0.55;
}
.dir-sidebar-lock {
  margin-left: auto;
  color: #c0c8d8;
  flex-shrink: 0;
}
</style>
